<template>
    <v-container style="padding-top: 80px;">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="verfinanzas" multiple>
                    <v-expansion-panel class="active-class">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Detalle General</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row justify="center">
                                <v-col cols="12" md="3">
                                    <v-list>
                                        <v-list-item-content>
                                            <span>Número de Escritura:</span>
                                            <span class="Texto">{{detalle.podnumescritura}}</span>
                                        </v-list-item-content>
                                    </v-list>
                                    <v-list>
                                        <v-list-item-content>
                                            <span>Flotilla:</span>
                                            <span class="Texto">{{detalle.flnomcomp}}</span>
                                        </v-list-item-content>
                                    </v-list>
                                    <v-list>
                                        <v-list-item-content>
                                            <span>Razón Social:</span>
                                            <span class="Texto">{{detalle.podrazonsocial}}</span>
                                        </v-list-item-content>
                                    </v-list>
                                </v-col>
                                <v-col cols="12" md="3">

                                    <v-list>
                                        <v-list-item-content>
                                            <span>Número de Copia:</span>
                                            <span class="Texto" v-if="detalle.podnumcopia != 0">{{detalle.podnumcopia}}</span>
                                        </v-list-item-content>
                                    </v-list>
                                    <v-list>
                                        <v-list-item-content>
                                            <span>Fecha Incio Vigencia:</span>
                                            <span class="Texto">{{detalle.podfhinivig}}</span>
                                        </v-list-item-content>
                                    </v-list>
                                </v-col>
                                <v-col cols="12" md="3">

                                    <v-list>
                                        <v-list-item-content>
                                            <span>Cliente:</span>
                                            <span class="Texto">{{detalle.clnombre}}</span>
                                        </v-list-item-content>
                                    </v-list>
                                    <v-list>
                                        <v-list-item-content>
                                            <span>Fecha Fin Vigencia:</span>
                                            <span class="Texto">{{detalle.podfhfinvig}}</span>
                                        </v-list-item-content>
                                    </v-list>

                                </v-col>
                            </v-row>
                            <v-row justify="center" v-if="detalle.documentoruta != ''">
                                <v-btn class="ma-2"
                                       @click="DescargarArchivo()"
                                       color="success">
                                    Descargar Archivo
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                            </v-row>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="verabogado" multiple>
                    <v-expansion-panel class="active-class">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Abogados</v-expansion-panel-header>
                        <v-expansion-panel-content v-if="ver">
                            <br />
                            <DataTable :url="urlabogado"
                                       :columns="headabogado"
                                       :params="displayabogado"
                                       :order="[]"
                                       @apiDT="apiDT = $event">
                            </DataTable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="vermovimiento" multiple>
                    <v-expansion-panel class="active-class">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Movimientos</v-expansion-panel-header>
                        <v-expansion-panel-content v-if="ver">
                            <br />
                            <DataTable :url="urlmovimiento"
                                       :columns="headmovimiento"
                                       :params="displaymovimiento"
                                       :order="[]"
                                       @apiDT="apiDT = $event">
                            </DataTable>
                            <v-row justify="center">
                                <v-btn class="ma-2"
                                       @click="Agregar()"
                                       color="primary">
                                    Agregar Movimiento
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <div v-show="showLightbox">
            <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                      @onClosed="CerrarVisor()" />
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import General from "@/services/Operacion/Operacion.service.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Archivos from '@/services/Archivos/Archivos.service.js';
    import LightBox from '@/components/pages/Visor/LightBox.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
            LightBox
        },
        data() {
            return {
                ver: false,
                verfinanzas: [0],
                verabogado: [0],
                vermovimiento: [0],
                showcargando: true,
                detalle: {},
                urlabogado: 'Operacion/DetalleApoderado',
                headabogado: [
                    { name: "prnombre", data: "prnombre", title: "Nombre", },
                    { name: "apodfhalta", data: "apodfhalta", title: "Fecha Alta" },
                ],
                displaymovimiento: {},
                urlmovimiento: 'Operacion/ObtenerMovimientos',
                headmovimiento: [
                    { name: "prnombre", data: "prnombre", title: "Nombre", },
                    { name: "nrreporte", data: "nrreporte", title: "N° de Reporte" },
                    { name: "svindice", data: "svindice", title: "N° de Índice", },
                    { name: "podfhalta", data: "podfhalta", title: "Fecha Alta" },
                    { name: "hpocomentario", data: "hpocomentario", title: "Comentarios", },
                ],
                displayabogado: {},

                isPDF: false,
                media: [{
                    src: '@/',
                    type: ''
                }],
                showLightbox: false,
                overlay: false,
            }
        },
        methods: {
            async CerrarVisor() {
                var img = {
                    src: '@/',
                    type: 'img'
                }
                this.media = [];
                this.media.push(img);
                this.showLightbox = false;
                await this.$refs.lightbox.showImage(0);
            },
            async DescargarArchivo() {
                this.showLightbox = false;
                this.overlay = true;
                this.media = this.media.filter(obj => obj.src == '@/');
                this.isPDF = /\.pdf$/i.test(this.detalle.documentoruta);
                console.log(this.isPDF);
                let formdata = new FormData();
                formdata.append("podnumescritura", this.detalle.podnumescritura)
                await General.DescargarArchivo(this, formdata).then(data => {
                    console.log(data);
                    if (data.error == false) {
                        var img = {
                            src: data.watch,
                            caption: '<h4>' + data.archivo + '</h4>',
                            type: this.isPDF == true ? 'pdf' : 'img',
                            width: '800px',
                        };
                        this.media.push(img);
                        this.media = this.media.filter(obj => obj.src !== '@/');
                        this.showLightbox = true;
                    }
                    else {
                        this.$swal(
                            "Atención",
                            data.msg,
                            "error"
                        );
                    }
                    this.overlay = false;
                });
            },
            Agregar() {
                this.$router.push({ name: 'AgregarMovimiento' });
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        async mounted() {
            if (window.sessionStorage.getItem("poderes") != null) {
                let poderes = await MetodosGenerales.obtenerSessionReporte('poderes');
                let form = new FormData();
                form.append("podclave", poderes.podclave);
                await General.DetallePoder(this, form).then(data => {
                    this.detalle = data[0];
                });
                this.ver = true;
                this.displayabogado = {
                    podclave: poderes.podclave
                }
                this.displaymovimiento = {
                    podclave: poderes.podclave
                }
            }
            else {

            }
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '275').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>
<style scoped>
    .title-card-style {
        padding: 1.5px !important;
        max-height: auto;
    }

    .card-title-text {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1em;
        color: white;
    }

    .Texto{
        font-weight: bold;
    }
</style>